module.exports = __webpack_public_path__ + "img/nodata@2x.4a79af19.png";